/**
 * Набор клавиатурных клавиш.
 */
export const Keys = {
  BACKSPACE: 'Backspace',
  TAB: 'Tab',
  ENTER: 'Enter',
  CAPS_LOCK: 'CapsLock',
  ESC: 'Escape',
  SPACE: ' ',
  PAGE_UP: 'PageUp',
  PAGE_DOWN: 'PageDown',
  END: 'End',
  HOME: 'Home',
  LEFT: 'ArrowLeft',
  UP: 'ArrowUp',
  RIGHT: 'ArrowRight',
  DOWN: 'ArrowDown',
  INSERT: 'Insert',
  DELETE: 'Delete'
};

/**
 * Проверяет совпадает ли название из `keys` с тем, что передано в `code`.
 *
 * @example
 * isKeyCode(event.key, [Keys.ESC, Keys.ENTER])
 *
 * @param code Код клавиши.
 * @param keys Список клавиш в виде строкового представления
 */
export function isKeyCode(code, keys) {
  return keys.some(value => Keys[value] === code || value === code);
}